var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Head'),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":4}},[_c('LeftBody')],1),_c('el-col',{attrs:{"span":20}},[_c('RightBody')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }